import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { FormFieldDate } from '.';
import { DateDisplay } from './DateDisplay';

interface Props {
  value?: string;
  previousValue?: string | null;
  onClose: () => void;
  config: FormFieldDate;
}

export const DateDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? zeroState : <DateDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? zeroState : <DateDisplay value={value} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
